import { Component } from '@angular/core';

@Component({
  selector: 'app-three-dots-blinking',
  templateUrl: './three-dots-blinking.component.html',
  styleUrls: ['./three-dots-blinking.component.scss'],
  standalone: false
})
export class ThreeDotsBlinkingComponent {

}
